import {
  type CoveoSearchApiQuery,
  type CoveoSearchApiResponse,
} from "types/Coveo";

const revalidateInterval =
  Number(process.env.NEXT_PUBLIC_COVEO_API_CACHE_DURATION) || 600;
const coveoOrganizationId =
  process.env.NEXT_PUBLIC_COVEO_ORGANIZATION_ID || "default";
const coveoSearchHub = process.env.NEXT_PUBLIC_COVEO_SEARCH_HUB || "default";
const coveoAccessToken = process.env.NEXT_PUBLIC_COVEO_ACCESS_TOKEN;

const coveoSearchEndpoint = `https://${coveoOrganizationId}.org.coveo.com/rest/search/v2`;

// Server-side Coveo search request. Uses Next's revalidate cache so identical
// queries within the cache window are served from the data cache instead of
// hitting the Coveo edge.
export const CoveoSearchRequest = async (
  query: CoveoSearchApiQuery,
): Promise<CoveoSearchApiResponse> => {
  const payload: CoveoSearchApiQuery = {
    ...query,
    searchHub: query.searchHub || coveoSearchHub,
  };

  const response = await fetch(coveoSearchEndpoint, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${coveoAccessToken}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
    next: {
      revalidate: revalidateInterval,
    },
  });

  return (await response.json()) as CoveoSearchApiResponse;
};
